import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal, Badge, GlitchDivider } from "@/components/site/primitives";
import { MapPin, Car, Train } from "lucide-react";

const FAQS = [
  { q: "What is the bag policy and costume prop policy?", a: "All foam and plastic props are peace-bonded at check-in — no real weapons, sharp edges, or functional replicas permitted. Bags are subject to a quick check at the door. Keep props under 6ft for everyone's safety on the runway and dance floor." },
  { q: "Is this event all-ages?", a: "Yes! This is a 100% family and all-ages friendly celebration. Kids 3 and under enter free. The bar serves exclusively non-alcoholic craft mocktails, so the whole multiverse crew is welcome." },
  { q: "What are the parking and transit options at RiNo ArtPark?", a: "The 38th & Blake RTD Station is just 3 blocks away, making transit the easiest option. Free street parking is available along Arkins Ct, with additional paid lots throughout the RiNo Art District." },
  { q: "Is food and drink available?", a: "Absolutely. Local Denver food trucks will be on-site alongside our signature craft mocktail bar — including The Leap of Faith, Sunflower Boba, and Spider-Punk Punch. Everything at the bar is 100% non-alcoholic." },
  { q: "What happens if it rains?", a: "No problem — the 5,000 sq ft historic indoor Truss House is fully enclosed and heated. The event runs rain or shine across both indoor and covered outdoor spaces." },
  { q: "Will you have security?", a: "Yes. We've hired off-duty police officers and a professional security team to keep the entire multiverse safe all night long." },
];

export default function Faq() {
  return (
    <div className="pt-24 md:pt-32">
      <section className="max-w-4xl mx-auto px-5 md:px-8 text-center">
        <Reveal>
          <Badge color="yellow">Know Before You Go</Badge>
          <h1 className="font-display text-6xl md:text-8xl uppercase mt-4">FAQ &amp; <span className="text-[#00f0ff]">Venue</span></h1>
        </Reveal>
      </section>

      <section className="max-w-3xl mx-auto px-5 md:px-8 py-16">
        <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <AccordionItem value={`item-${i}`} className="glass-chroma rounded-2xl px-6 border-none" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="font-head font-bold text-left text-lg hover:no-underline hover:text-[#00f0ff] py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/70 font-head text-base pb-5 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            </Reveal>
          ))}
        </Accordion>
      </section>

      <GlitchDivider />

      {/* VENUE MAP */}
      <section className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <Reveal>
            <div className="font-mono2 text-xs tracking-[0.3em] text-[#ff0055] uppercase mb-3">The Venue</div>
            <h2 className="font-display text-5xl md:text-6xl uppercase">The Truss House<br /><span className="text-[#ffe600]">@ RiNo ArtPark</span></h2>
            <p className="text-white/70 font-head mt-5">3400 Arkins Court, Denver, CO 80216</p>
            <ul className="mt-6 space-y-4 font-head">
              <li className="flex gap-3"><MapPin className="text-[#00f0ff] shrink-0" /> 5,000 sq ft historic indoor warehouse — fully enclosed &amp; heated.</li>
              <li className="flex gap-3"><Train className="text-[#00f0ff] shrink-0" /> 38th &amp; Blake RTD Station, 3 blocks away.</li>
              <li className="flex gap-3"><Car className="text-[#00f0ff] shrink-0" /> Free street parking along Arkins Ct.</li>
            </ul>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="glass-chroma rounded-2xl p-2 overflow-hidden">
              <iframe
                data-testid="venue-map"
                title="RiNo ArtPark map"
                src="https://www.google.com/maps?q=3400+Arkins+Court+Denver+CO+80216&output=embed"
                className="w-full h-[380px] rounded-xl border-0"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
